const instituicoesSuperioresList = [
  "1 - UNIVERSIDADE FEDERAL DE MATO GROSSO",
  "2 - UNIVERSIDADE DE BRASILIA",
  "3 - UNIVERSIDADE FEDERAL DE SERGIPE",
  "4 - UNIVERSIDADE FEDERAL DO AMAZONAS",
  "5 - UNIVERSIDADE FEDERAL DO PIAUI",
  "12 - UNIVERSIDADE FEDERAL DO RIO GRANDE",
  "13 - UNIVERSIDADE DE CAXIAS DO SUL",
  "14 - UNIVERSIDADE DO VALE DO RIO DOS SINOS",
  "19 - FACULDADE DE CIENCIAS CONTABEIS E DE ADMINISTRACAO DE EMPRESAS",
  "29 - UNIVERSIDADE ESTADUAL DO CEARA",
  "30 - UNIVERSIDADE PROFESSOR EDSON ANTONIO VELANO",
  "31 - CENTRO DE EDUCACAO TECNICA DA UTRAMIG",
  "141 - FACULDADE DE DIREITO DE VARGINHA FADIVA",
  "142 - CENTRO UNIVERSITARIO DO TRIANGULO",
  "172 - INSTITUTO DE DIREITO DO NORTE IDN MANAUS",
  "192 - FACULDADE SOUZA MARQUES",
  "193 - FACULDADE DE ENGENHARIA SOUZA MARQUES",
  "275 - UNIVERSIDADE DO VALE DO PARAIBA",
  "276 - FACULDADE DE DIREITO DE SOROCABA",
  "277 - CENTRO UNIVERSITARIO AUGUSTO MOTTA",
  "315 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DO ESPIRITO SANTO",
  "316 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DO SERTAO PERNAMBUCANO",
  "317 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DE SANTA CATARINA",
  "318 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DO RIO DE JANEIRO",
  "319 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DA BAHIA",
  "320 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DO MARANHAO",
  "531 - FACULDADE MILTON CAMPOS",
  "536 - ESCOLA SUPERIOR DE PROPAGANDA E MARKETING",
  "555 - UNIVERSIDADE DE FORTALEZA",
  "556 - CONSERVATORIO DE MUSICA DE NITEROI",
  "557 - ESCOLA DE MUSICA E BELAS ARTES DO PARANA",
  "569 - UNIVERSIDADE FEDERAL DO PARA",
  "570 - UNIVERSIDADE FEDERAL DO RIO GRANDE DO NORTE",
  "571 - UNIVERSIDADE FEDERAL DO PARANA",
  "572 - UNIVERSIDADE FEDERAL FLUMINENSE",
  "573 - UNIVERSIDADE FEDERAL DO ESPIRITO SANTO",
  "574 - UNIVERSIDADE FEDERAL RURAL DO RIO DE JANEIRO",
  "575 - UNIVERSIDADE FEDERAL DE MINAS GERAIS",
  "594 - CENTRO FEDERAL DE EDUCACAO TECNOLOGICA DE MINAS GERAIS",
  "595 - UNIVERSIDADE FEDERAL DE ALFENAS",
  "596 - UNIVERSIDADE FEDERAL DOS VALES DO JEQUITINHONHA E MUCURI",
  "597 - UNIVERSIDADE FEDERAL DO TRIANGULO MINEIRO",
  "598 - UNIVERSIDADE FEDERAL DE ITAJUBA UNIFEI",
  "599 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DA BAHIA",
  "600 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DO MARANHAO",
  "636 - ESCOLA SUPERIOR DE PROPAGANDA E MARKETING",
  "637 - FACULDADE DE ENGENHARIA SAO PAULO",
  "638 - FACULDADE MILTON CAMPOS",
  "6473 - FACULDADE DE CIENCIAS E TECNOLOGIA DE BIRIGUI",
  "6490 - FACULDADE DE TECNOLOGIA DE MAUA",
  "6512 - FACULDADE DE TECNOLOGIA DE INDAIATUBA",
  "6528 - FACULDADE DE CIENCIAS APLICADAS DE LIMOEIRO",
  "662 - FACULDADES INTEGRADAS CORACAO DE JESUS",
  "663 - UNIVERSIDADE SALGADO DE OLIVEIRA",
  "664 - UNIVERSIDADE VILA VELHA",
  "668 - CENTRO UNIVERSITARIO DE ENSINO SUPERIOR DO AMAZONAS",
  "669 - UNIVERSIDADE NILTON LINS",
  "670 - UNIVERSIDADE SAO FRANCISCO",
  "744 - FACULDADE DE ANICUNS",
  "745 - INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE SAO MANUEL",
  "746 - UNIVERSIDADE REGIONAL DO CARIRI",
  "751 - FACULDADE DA ILHA",
  "752 - FACULDADE CATOLICA DE PARA DE MINAS",
  "753 - FACULDADE DE CIENCIAS HUMANAS DO SERTAO CENTRAL",
  "754 - CENTRO SUPERIOR UNA DE CATALAO",
  "755 - CENTRO DE ENSINO SUPERIOR DE JATAI",
  "756 - UNIVERSIDADE ESTADUAL DO PIAUI",
  "7952 - FACULDADE DE TECNOLOGIA DE JACAREI",
  "7977 - FACULDADE DE TECNOLOGIA DE ITAQUERA",
  "848 - FACULDADE PARAIBANA DE PROCESSAMENTO DE DADOS",
  "10613 - FACULDADE FASUP",
  "10685 - FACULDADE MULTIVIX SAO MATEUS",
  "10836 - FACULDADE UNIAO ARARUAMA DE ENSINO S/S LTDA.",
  "124 - FACULDADE PIO DECIMO",
  "125 - FACULDADES INTEGRADAS DE BAURU",
  "126 - FACULDADE DE CIENCIAS SOCIAIS DE GUARAPOABA",
  "127 - FACULDADE DE CIENCIAS JURIDICAS DE ALTAMIRA",
  "128 - FACULDADE DE CIENCIAS JURIDICAS DE POUSO ALEGRE",
  "129 - FACULDADE UNOPAR DE CIENCIAS JURIDICAS DE SETE LAGOAS",
  "130 - FACULDADE IBRA DO MATO GROSSO DO SUL",
  "131 - FACULDADE DE TECNOLOGIA DE SUMARE",
  "132 - LINK SCHOOL OF BUSINESS",
  "133 - FACULDADE INSTITUTO DE ENSINO SUPERIOR",
  "134 - FACULDADE DINAMO EDUCACAO",
  "135 - ESCOLA DE FORMACAO COMPLEMENTAR DO EXERCITO",
  "136 - ESCOLA DE COMANDO E ESTADOMAIOR DO EXERCITO",
  "137 - ESCOLA DE EQUITACAO DO EXERCITO",
  "138 - FACULDADE MEGA",
  "139 - FACULDADE AGAPE DE SAO FELIX",
  "140 - UNIVERSIDADE DE VASSOURAS",
  "14724 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DO PARANA",
  "14727 - FACULDADE PROGRESSO",
  "14738 - FACULDADE FELUMA SAUDE TECNOLOGIA E CIENCIA",
  "14782 - FACULDADE DE TECNOLOGIA SENAI CASCAVEL",
  "14783 - FACULDADE DE TECNOLOGIA SENAI TOLEDO",
  "14784 - FACULDADE DE TECNOLOGIA SENAI CURITIBA",
  "17161 - CENTRO DE FORMACAO TREINAMENTO E APERFEICOAMENTO",
  "17165 - FACULDADE UNILAGOS",
  "17200 - FACULDADE BRASILEIRA DE TRIBUTACAO",
  "17224 - FACULDADE CESMAC DO SERTAO",
  "17226 - FACULDADE CESMAC DO AGRESTE",
  "17269 - INSTITUTO DE EDUCACAO SUPERIOR E INOVACAO PERSONA",
  "17277 - FACULDADE SENAC CRICIUMA",
  "18623 - FACULDADE ALIANCA DO MARANHAO",
  "18625 - FACULDADE ANHANGUERA DE VITORIA DA CONQUISTA",
  "19951 - FACULDADE DE GESTAO E NEGOCIOS DE MACEIO",
  "19952 - FACULDADE DE GESTAO E NEGOCIOS DE CACHOEIRINHA",
  "19956 - FACULDADE UNIRB JOAO PESSOA",
  "21435 - ESCOLA DE FORMACAO COMPLEMENTAR DO EXERCITO",
  "21436 - ESCOLA DE COMANDO E ESTADOMAIOR DO EXERCITO",
  "21437 - ESCOLA DE EQUITACAO DO EXERCITO",
  "21441 - ESCOLA DE EQUITACAO DO EXERCITO",
  "21442 - FACULDADE MEGA",
  "21444 - FACULDADE AGAPE DE SAO FELIX",
  "21446 - FACULDADE DO SERTAO DO SAO FRANCISCO",
  "2145 - FACULDADE PROMOVE DE TECNOLOGIA",
  "2146 - FACULDADE DO ACRE",
  "21508 - INSTITUTO LEGISLATIVO BRASILEIRO",
  "21509 - INSTITUTO DE ENSINO E PESQUISA DO HOSPITAL SIRIOLIBANES",
  "21514 - FACULDADE DO SERTAO DO SAO FRANCISCO",
  "21519 - FACULDADE ATITUS EDUCACAO PORTO ALEGRE",
  "21537 - FACULDADE DE SANTO ANGELO",
  "21540 - FACULDADE FREIRE DE ENSINO",
  "21932 - INSTITUTO UNA DE JATAI",
  "21935 - FUNDACAO ESCOLA LINCE KEMPIM",
  "21937 - FACULDADE INTEGRADA DE CAMPO GRANDE",
  "21978 - FACULDADE EDUFOR DE SALVADOR",
  "21982 - FACULDADE INTEGRADA CETE",
  "21983 - FACULDADE MORUMBI",
  "21992 - FACULDADE GUAIRACA DE PRUDENTOPOLIS",
  "21993 - FACULDADE UNINTA IGUATU",
  "21995 - FACULDADE DE TECNOLOGIA SENAC CURITIBA",
  "22232 - FACULDADE DE CIENCIAS JURIDICAS DE ALTAMIRA",
  "22235 - FACULDADE DE CIENCIAS JURIDICAS DE POUSO ALEGRE",
  "22236 - FACULDADE UNOPAR DE CIENCIAS JURIDICAS DE SETE LAGOAS",
  "22246 - FACULDADE MATIAS MACHLINE",
  "22248 - FACULDADE SUCESSO",
  "22249 - FACULDADE KEEP EDUC",
  "22252 - FACULDADE UNIBRAS DO PARA",
  "22257 - FACULDADE DE DIREITO UNIAVAN DE ITAPEMA",
  "22260 - FACULDADE MAIS DE ITABERAI",
  "22424 - FACULDADE ESAMC GOIANIA",
  "22425 - FACULDADE ESAMC FRANCA",
  "23867 - FACULDADE DE TECNOLOGIA DE SUMARE",
  "23868 - LINK SCHOOL OF BUSINESS",
  "23875 - FACULDADE INSTITUTO DE ENSINO SUPERIOR",
  "24259 - FACULDADE ALFFA PRIME",
  "24263 - FACULDADE METROPOLITANA DO PARA",
  "24861 - FACULDADE ATENAS DO SUL BAIANO",
  "24862 - FACULDADE DE TECNOLOGIA SENAC CASCAVEL",
  "24864 - INSTITUTO DE EDUCACAO SUPERIOR E INOVACAO INVENIO",
  "24966 - FACULDADE UNIAVAN RIO DO SUL",
  "24968 - FACULDADE PITAGORAS DE PARANAGUA",
  "24979 - INSTITUTO BRASIL DE ENSINO SUPERIOR",
  "25656 - INSTITUTO PLENITUDE EDUCACAO",
  "25657 - FACULDADE ITH",
  "25665 - FACULDADE FRACTAL",
  "26974 - ESCOLA DO FUTURO DO ESTADO DE GOIAS EM ARTES BASILEU FRANCA",
  "27012 - FACULDADE ANCLIVEPA PORTO ALEGRE",
  "275 - UNIVERSIDADE DO VALE DO PARAIBA",
  "276 - FACULDADE DE DIREITO DE SOROCABA",
  "277 - CENTRO UNIVERSITARIO AUGUSTO MOTTA",
  "2765 - INSTITUTO DE CIENCIAS RELIGIOSAS LUMEN CHRISTI",
  "2766 - FACULDADE EMPRESARIAL DE CHAPECO",
  "2767 - INSTITUTO SUPERIOR DE EDUCACAO DA AIMORES M G",
  "29 - UNIVERSIDADE ESTADUAL DO CEARA",
  "30 - UNIVERSIDADE PROFESSOR EDSON ANTONIO VELANO",
  "31 - CENTRO DE EDUCACAO TECNICA DA UTRAMIG",
  "3153 - INSTITUTO SUPERIOR DE EDUCACAO CANTAREIRA",
  "3154 - FACULDADE DE TECNOLOGIA SENAI RIO DO SUL",
  "3155 - FACULDADE DE TECNOLOGIA SENAI JARAGUA DO SUL",
  "3159 - FACULDADE DE TECNOLOGIA SENAI FLORIANOPOLIS",
  "3160 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DE ALAGOAS",
  "3161 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DO SERTAO PERNAMBUCANO",
  "3162 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DE SANTA CATARINA",
  "3163 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DO RIO DE JANEIRO",
  "3164 - INSTITUTO FEDERAL DE EDUCACAO CIENCIA E TECNOLOGIA DA BAHIA",
  "3939 - FACULDADE ALIANCA DE ITABERAI",
  "3940 - FACULDADE DE ENSINO SUPERIOR SANTA BARBARA",
  "3941 - FACULDADE COMUNITARIA DE SANTA BARBARA",
  "5312 - CENTRO UNIVERSITARIO UNIFAAT",
  "5313 - FACULDADES UNIFICADAS DE CATAGUASES",
  "5314 - FACULDADES DOCTUM DE GUARAPARI",
  "5327 - CIODONTO POS GRADUACAO SAO PAULO I",
  "5328 - CIODONTO POS GRADUACAO SERTAOZINHO",
  "5329 - CIODONTO POS GRADUACAO BELO HORIZONTE II",
  "5336 - CIODONTO POS GRADUACAO PORTO VELHO",
  "5337 - CIODONTO POS GRADUACAO PORTO ALEGRE",
  "5338 - CIODONTO POS GRADUACAO RECIFE",
  "5368 - CIODONTO POS GRADUACAO RIO DE JANEIRO II",
  "5369 - FACULDADES INTEGRADAS ASMEC",
  "5370 - CENTRO UNIVERSITARIO DOCTUM DE TEOFILO OTONI",
];

export default instituicoesSuperioresList;
